import styled from 'styled-components';

export const SwitcherContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const TabSwitcherContainerLeft = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

